<template>
    <div class="gingo-section" v-if="landArr != null" id="menu-link-ginkgo">
        <div class="container">
            <sectionTitle :options="[{ title : landArr.gingo_title}]"></sectionTitle>
            <sectionBaner :options="[{ bg: landArr.gingo_quote_img, title : landArr.gingo_quote_title, desc: landArr.gingo_quote_desc}]"></sectionBaner>
            <sectionDescColumn :options="[{ desc_left : landArr.gingo_desc_left, desc_right: landArr.gingo_desc_right}]" class="section-desc-column-gingo"></sectionDescColumn>
            <sectionImagesMobile :options="[{ images: landArr.gingo_cards[0].images}]" v-if="isMobileGlobal"></sectionImagesMobile>
            <landImagesGrid :options="[{ cards: landArr.gingo_cards, grid_img : landArr.gingo_img}]" class="land-images-grid-mix"></landImagesGrid>
        </div>
    </div>
</template>

<script>
    import sectionTitle from '@/components/partials/section-title.vue'
    import sectionBaner from '@/components/partials/section-baner.vue'
    import sectionDescColumn from '@/components/partials/section-desc-column.vue'
    import landImagesGrid from '@/components/landscaping/land-images-grid.vue'
    import sectionImagesMobile from '@/components/partials/section-images-mobile.vue'
    import {mapGetters} from 'vuex'
    export default {
        name: 'land-section',
        data () {
            return {
            }
        },
        computed: mapGetters({
            landArr: 'loadLandArr',
            isMobileGlobal: 'loadisMobileGlobal',
        }),
        components: {
            sectionTitle,
            sectionBaner,
            sectionDescColumn,
            landImagesGrid,
            sectionImagesMobile,
        },
        methods: {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/landscaping/gingo-section.scss';
    @import '@/styles/components/landscaping/respond/gingo-section-respond.scss';
</style>